import React from 'react';
import classNames from 'classnames';
import { Checkbox } from 'components/index';

import styles from './select-all-switch.module.scss';

export interface Props {
	selectAllText?: string;
	onSelectAll: (checked: boolean, indeterminate: boolean) => void;
	checked: boolean;
	indeterminate: boolean;
	allValuesCount?: number;
	className?: string;
}

export const DEFAULT_SELECT_ALL_THRESHOLD = 7;
export const SELECT_ALL_TEXT = 'Select All';

const SelectAllSwitch = ({
	selectAllText = SELECT_ALL_TEXT,
	onSelectAll,
	checked,
	indeterminate,
	allValuesCount,
	className
}: Props) => {
	return (
		<div
			className={classNames(
				styles.selectAllSwitch,
				{
					[styles.allSelected]: checked || indeterminate
				},
				className
			)}
			// keep previous component name data-test-id for backward compatibility
			data-test-id="tree-select-all-switch"
		>
			<Checkbox
				onChange={() => onSelectAll(!checked, indeterminate)}
				checked={checked}
				indeterminate={indeterminate}
			/>
			<span className={styles.selectAllSwitchContent} onClick={() => onSelectAll(!checked, indeterminate)}>
				{selectAllText} {typeof allValuesCount === 'number' && <span>({allValuesCount})</span>}
			</span>
		</div>
	);
};

export default SelectAllSwitch;
